// Auto-generated skeleton for CraftsmanTaskStatusText

export const CraftsmanTaskStatusText: Api.CraftsmanTaskStatusText = {
  id: 0,
  text: '',
  status_id: 0,
  created: null,
  updated: null,
};

